import { Paginator } from '@onwardtravelsolutions/package-react/Types';

type PaginationSummaryProps = {
    paginator: Paginator;
    className?: string;
};

export default function PaginationSummary({
    paginator,
    className = '',
}: PaginationSummaryProps) {
    const { from, to, total } = paginator;

    return (
        <span
            className={`text-small text-gray-500 dark:text-gray-200 ${className}`}
        >
            Showing {from} to {to} of {total} results
        </span>
    );
}
